// URL search params for /search. A query outside 2..200 characters (after trimming) is dropped,
// and every key is always returned (see files/search-params.ts).
import { pageParam } from '../files/search-params.ts';

const MIN_QUERY = 2;
const MAX_QUERY = 200;

export const SEARCH_LIMITS = { min: MIN_QUERY, max: MAX_QUERY } as const;

export interface SiteSearch {
  readonly q?: string | undefined;
  readonly page?: number | undefined;
}

export function validateSiteSearch(search: Record<string, unknown>): SiteSearch {
  const raw = search['q'];
  const q = typeof raw === 'string' ? raw.trim() : '';
  return {
    q: q.length >= MIN_QUERY && q.length <= MAX_QUERY ? q : undefined,
    page: pageParam(search['page']),
  };
}
